module.exports = __webpack_public_path__ + "assets/img/40a959c027be72a05da60045ea1e3b2b.svg";